// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** colors **/

:root {
  --midnight: #122634;
  --light-midnight: #455966;
  --pool: #b2ece7;
  --chartreuse: #d8d239;
  --cabana: #07a0ad;
  --peach: #ff9876;
  --limoncello: #f5f6b4;
  --nectar: #ffd6c9;
  --duvet: #ffffff;
  --linen: #f9f9f9;
  --ink: #000000;
}

html,
body {
  background-color: hsl(var(--linen));
}

/** typography **/

body {
  font-family: 'Poppins', sans-serif;
}

.header-1 {
  font-family: 'Poppins', sans-serif;
  font-size: 60px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: -1.08px;
  color: var(--midnight);
}

.header-2 {
  font-family: 'Poppins', sans-serif;
  font-size: 40px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: -1.5px;
  color: var(--midnight);
}

.header-3 {
  font-family: 'Poppins', sans-serif;
  font-size: 25px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: -0.94px;
  color: var(--midnight);
}

.header-4 {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.14px;
  color: var(--light-midnight);
}

.header-5 {
  font-family: 'Poppins', sans-serif;
  font-size: 13.3px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.41;
  letter-spacing: 1.62px;
  color: var(--light-midnight);
}

/** buttons **/

.btn{
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
}

.btn-outline{
  border-width: 2px;
}

.btn-outline.btn-secondary{
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: var(--fallback-s,oklch(var(--s)/var(--tw-border-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-p,oklch(var(--p)/var(--tw-text-opacity)));
}

.btn-outline.btn-accent{
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: var(--fallback-a,oklch(var(--a)/var(--tw-border-opacity)));
  --tw-text-opacity: 1;
  color: var(--fallback-p,oklch(var(--p)/var(--tw-text-opacity)));
}

/** forms **/

.checkin-input{
  flex-shrink: 1;
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1rem;
  line-height: 2;
  line-height: 1.5rem;
  border-radius: var(--rounded-btn, 0.5rem);
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
}

.checkin-input input:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.checkin-input[list]::-webkit-calendar-picker-indicator{
  line-height: 1em;
}

.checkin-input{
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}

.checkin-input:focus,.checkin-input:focus-within{
  box-shadow: none;
  border-color: var(--fallback-bc,oklch(var(--bc)/0.2));
  outline-style: solid;
  outline-width: 2px;
  outline-offset: 2px;
  outline-color: var(--fallback-bc,oklch(var(--bc)/0.2));
}

.checkin-input:disabled,.checkin-input[disabled]{
  cursor: not-allowed;
  --tw-border-opacity: 1;
  border-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-border-opacity)));
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  color: var(--fallback-bc,oklch(var(--bc)/0.4));
}

.checkin-input:disabled::-moz-placeholder, .checkin-input[disabled]::-moz-placeholder{
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}

.checkin-input:disabled::placeholder,.checkin-input[disabled]::placeholder{
  color: var(--fallback-bc,oklch(var(--bc)/var(--tw-placeholder-opacity)));
  --tw-placeholder-opacity: 0.2;
}

.mockup-browser .mockup-browser-toolbar .checkin-input{
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 1.75rem;
  width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b2,oklch(var(--b2)/var(--tw-bg-opacity)));
  padding-left: 2rem;
  direction: ltr;
}

.mockup-browser .mockup-browser-toolbar .checkin-input:before{
  content: "";
  position: absolute;
  left: 0.5rem;
  top: 50%;
  aspect-ratio: 1 / 1;
  height: 0.75rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 2px;
  border-color: currentColor;
  opacity: 0.6;
}

.mockup-browser .mockup-browser-toolbar .checkin-input:after{
  content: "";
  position: absolute;
  left: 1.25rem;
  top: 50%;
  height: 0.5rem;
  --tw-translate-y: 25%;
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  border-width: 1px;
  border-color: currentColor;
  opacity: 0.6;
}

.checkin-input, input.checkin-input{
  height: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 2;
}

.checkin-input{
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}

.checkin-input:focus{
  --tw-border-opacity: 1;
  border-color: rgb(7 160 173 / var(--tw-border-opacity));
  outline: none;
}

/** date picker **/

.react-datepicker__day--selected,
.react-datepicker__day--selected:hover,
.react-datepicker__day--keyboard-selected:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(7 160 173 / var(--tw-bg-opacity));
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected{
  --tw-bg-opacity: 1;
  background-color: rgb(178 236 231 / var(--tw-bg-opacity));
}

.react-datepicker__input-container{
  display: flex;
  flex-direction: row;
}

/** tables **/

table.checkin-table{
  width: 100%;
  border-collapse: collapse;
}

table.checkin-table th{
  font-weight: 600;
}

table.checkin-table td,
th{
  padding: 0.5rem;
  text-align: left;
  vertical-align: middle;
}

/** modals **/

.help-modal-box{
  max-height: calc(100vh - 5em);
  grid-column-start: 1;
  grid-row-start: 1;
  width: 91.666667%;
  max-width: 32rem;
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-bottom-right-radius: var(--rounded-box, 1rem);
  border-bottom-left-radius: var(--rounded-box, 1rem);
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
  --tw-bg-opacity: 1;
  background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
  padding: 1.5rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-duration: 200ms;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.modal-open .help-modal-box,
.modal-toggle:checked + .modal .help-modal-box,
.modal:target .help-modal-box,
.modal[open] .help-modal-box{
  --tw-translate-y: 0px;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.modal-top :where(.help-modal-box){
  width: 100%;
  max-width: none;
  --tw-translate-y: -2.5rem;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-bottom-right-radius: var(--rounded-box, 1rem);
  border-bottom-left-radius: var(--rounded-box, 1rem);
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.modal-middle :where(.help-modal-box){
  width: 91.666667%;
  max-width: 32rem;
  --tw-translate-y: 0px;
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: var(--rounded-box, 1rem);
  border-bottom-left-radius: var(--rounded-box, 1rem);
}

.modal-bottom :where(.help-modal-box){
  width: 100%;
  max-width: none;
  --tw-translate-y: 2.5rem;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-top-left-radius: var(--rounded-box, 1rem);
  border-top-right-radius: var(--rounded-box, 1rem);
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.help-modal-box{
  margin: 0px;
  max-width: 1280px;
  padding: 0px;
  min-height: 95%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/checkin.css"],"names":[],"mappings":"AAEA,aAAa;;AAEb;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,iBAAiB;;AAEjB;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,cAAc;;AAGZ;EAAA,kBAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;;AAIxB;EAAA;AAAe;;AAIf;EAAA,iBAA6C;EAA7C,sBAA6C;EAA7C,wEAA6C;EAA7C,oBAA6C;EAA7C;AAA6C;;AAI7C;EAAA,iBAA0C;EAA1C,sBAA0C;EAA1C,wEAA0C;EAA1C,oBAA0C;EAA1C;AAA0C;;AAG5C,YAAY;;AAGV;EAAA,cAA6D;EAA7D,YAA6D;EAA7D,kBAA6D;EAA7D,mBAA6D;EAA7D,eAA6D;EAA7D,cAA6D;EAA7D,mBAA6D;EAA7D,yCAA6D;EAA7D,iBAA6D;EAA7D,yBAA6D;EAA7D,kBAA6D;EAA7D;AAA6D;;AAA7D;EAAA,8BAA6D;EAA7D;AAA6D;;AAA7D;EAAA;AAA6D;;AAA7D;EAAA;AAA6D;;AAA7D;EAAA,gBAA6D;EAA7D,qDAA6D;EAA7D,oBAA6D;EAA7D,kBAA6D;EAA7D,mBAA6D;EAA7D;AAA6D;;AAA7D;EAAA,mBAA6D;EAA7D,sBAA6D;EAA7D,0EAA6D;EAA7D,kBAA6D;EAA7D,0EAA6D;EAA7D;AAA6D;;AAA7D;EAAA,wEAA6D;EAA7D;AAA6D;;AAA7D;EAAA,wEAA6D;EAA7D;AAA6D;;AAA7D;EAAA,kBAA6D;EAA7D,iBAA6D;EAA7D,kBAA6D;EAA7D,cAA6D;EAA7D,eAA6D;EAA7D,YAA6D;EAA7D,gBAA6D;EAA7D,uBAA6D;EAA7D,mBAA6D;EAA7D,kBAA6D;EAA7D,0EAA6D;EAA7D,kBAA6D;EAA7D;AAA6D;;AAA7D;EAAA,WAA6D;EAA7D,kBAA6D;EAA7D,YAA6D;EAA7D,QAA6D;EAA7D,mBAA6D;EAA7D,eAA6D;EAA7D,sBAA6D;EAA7D,+LAA6D;EAA7D,qBAA6D;EAA7D,iBAA6D;EAA7D,0BAA6D;EAA7D;AAA6D;;AAA7D;EAAA,WAA6D;EAA7D,kBAA6D;EAA7D,aAA6D;EAA7D,QAA6D;EAA7D,cAA6D;EAA7D,qBAA6D;EAA7D,mBAA6D;EAA7D,+LAA6D;EAA7D,qBAA6D;EAA7D,iBAA6D;EAA7D,0BAA6D;EAA7D;AAA6D;;AAA7D;EAAA,YAA6D;EAA7D,kBAA6D;EAA7D,mBAA6D;EAA7D,mBAA6D;EAA7D,oBAA6D;EAA7D;AAA6D;;AAA7D;EAAA,iBAA6D;EAA7D,sBAA6D;EAA7D;AAA6D;;AAI7D;EAAA,sBAAoB;EAApB,uDAAoB;EACpB;AADoB;;AAItB,kBAAkB;;AAKhB;;;EAAA,kBAAgB;EAAhB;AAAgB;;AAOd;;;;EAAA,kBAAc;EAAd;AAAc;;AAIhB;EAAA,aAAoB;EAApB;AAAoB;;AAGtB,aAAa;;AAGX;EAAA,WAAa;EACb;AADa;;AAKb;EAAA;AAAoB;;AAKpB;;EAAA,eAAU;EACV,gBAAgB;EAChB;AAFU;;AAKZ,aAAa;;AAGX;EAAA,6BAAwC;EAAxC,oBAAwC;EAAxC,iBAAwC;EAAxC,iBAAwC;EAAxC,gBAAwC;EAAxC,gBAAwC;EAAxC,gBAAwC;EAAxC,+LAAwC;EAAxC,oDAAwC;EAAxC,mDAAwC;EAAxC,gDAAwC;EAAxC,iDAAwC;EAAxC,kBAAwC;EAAxC,0EAAwC;EAAxC,eAAwC;EAAxC,gKAAwC;EAAxC,wJAAwC;EAAxC,iLAAwC;EAAxC,wDAAwC;EAAxC,sDAAwC;EAAxC,0BAAwC;EAAxC,mDAAwC;EAAxC,gBAAwC;EAAxC;AAAwC;;AAAxC;;;;EAAA,qBAAwC;EAAxC,eAAwC;EAAxC,eAAwC;EAAxC;AAAwC;;AAAxC;EAAA,WAAwC;EAAxC,eAAwC;EAAxC,yBAAwC;EAAxC,eAAwC;EAAxC,eAAwC;EAAxC,+LAAwC;EAAxC,oDAAwC;EAAxC,mDAAwC;EAAxC,2BAAwC;EAAxC;AAAwC;;AAAxC;EAAA,iBAAwC;EAAxC,gBAAwC;EAAxC,qBAAwC;EAAxC,gBAAwC;EAAxC,gBAAwC;EAAxC,+LAAwC;EAAxC,gDAAwC;EAAxC,iDAAwC;EAAxC,oDAAwC;EAAxC;AAAwC;;AAAxC;EAAA,WAAwC;EAAxC,eAAwC;EAAxC,wBAAwC;EAAxC,eAAwC;EAAxC,eAAwC;EAAxC,+LAAwC;EAAxC,gDAAwC;EAAxC,iDAAwC;EAAxC,+BAAwC;EAAxC;AAAwC;;AAAxC;EAAA,WAAwC;EAAxC,iBAAwC;EAAxC,YAAwC;EACxC;AADwC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n/** colors **/\n\n:root {\n  --midnight: #122634;\n  --light-midnight: #455966;\n  --pool: #b2ece7;\n  --chartreuse: #d8d239;\n  --cabana: #07a0ad;\n  --peach: #ff9876;\n  --limoncello: #f5f6b4;\n  --nectar: #ffd6c9;\n  --duvet: #ffffff;\n  --linen: #f9f9f9;\n  --ink: #000000;\n}\n\nhtml,\nbody {\n  background-color: hsl(var(--linen));\n}\n\n/** typography **/\n\nbody {\n  font-family: 'Poppins', sans-serif;\n}\n\n.header-1 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 60px;\n  font-weight: 300;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.36;\n  letter-spacing: -1.08px;\n  color: var(--midnight);\n}\n\n.header-2 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 40px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.13;\n  letter-spacing: -1.5px;\n  color: var(--midnight);\n}\n\n.header-3 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 25px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.8;\n  letter-spacing: -0.94px;\n  color: var(--midnight);\n}\n\n.header-4 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: -0.14px;\n  color: var(--light-midnight);\n}\n\n.header-5 {\n  font-family: 'Poppins', sans-serif;\n  font-size: 13.3px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.41;\n  letter-spacing: 1.62px;\n  color: var(--light-midnight);\n}\n\n/** buttons **/\n\n.btn {\n  @apply font-bold text-xl;\n}\n\n.btn-outline {\n  @apply border-2;\n}\n\n.btn-outline.btn-secondary {\n  @apply text-primary border-2 border-secondary;\n}\n\n.btn-outline.btn-accent {\n  @apply text-primary border-2 border-accent;\n}\n\n/** forms **/\n\n.checkin-input {\n  @apply input input-md input-bordered border-2 border-gray-200;\n}\n\n.checkin-input:focus {\n  @apply border-cabana;\n  outline: none;\n}\n\n/** date picker **/\n\n.react-datepicker__day--selected,\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--keyboard-selected:hover{\n  @apply bg-cabana;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n    @apply bg-pool;\n}\n\n.react-datepicker__input-container {\n  @apply flex flex-row;\n}\n\n/** tables **/\n\ntable.checkin-table {\n  @apply w-full;\n  border-collapse: collapse;\n}\n\ntable.checkin-table th {\n  @apply font-semibold;\n}\n\ntable.checkin-table td,\nth {\n  @apply p-2;\n  text-align: left;\n  vertical-align: middle;\n}\n\n/** modals **/\n\n.help-modal-box {\n  @apply modal-box max-w-screen-xl p-0 m-0;\n  min-height: 95%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
